import H from 'history';
import { createContext, useContext } from 'react';
import { Action } from 'redux';

import { IResellerConfig } from '~/config/shared/reseller-config';
import { ECurrencyType } from '~/src/dash/api/exchange-rates';
import { mediaSize } from '~/src/dash/components/layout/common';
import { IStore } from '~/src/dash/reducers/store';

interface IBaseStore extends IStore {
  location: H.Location;
  isSuperUser: boolean;
  isDemoUser: boolean;
  children: any;
  currencyMultiplier: number;
  currencySymbol: string;
  currencyType: ECurrencyType;
  dispatch: (action: Action<any>) => any;
  resellerCfg: IResellerConfig;
  [key: string]: any;
}

export const BaseContext = createContext({} as IBaseStore);
export const useBaseStore = () => useContext(BaseContext);

export interface IBaseState {
  isNavExpanded: boolean;
  totalWidth: number | null;
  totalHeight: number | null;
  mediaSize: mediaSize;
}

export const BaseContextState = createContext({} as IBaseState);
export const useBaseState = () => useContext(BaseContextState);

export const BaseConfig = createContext({} as any);
export const useBaseConfig = () => useContext(BaseConfig);
